const apiUrl = process.env.REACT_APP_API_URL

export async function getUserProfile() {
    const token = localStorage.getItem('token')
    const userId = localStorage.getItem('userId')

    if (!token || !userId) {
        throw new Error('User not authenticated')
    }

    const response = await fetch(`${apiUrl}/me/${userId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    })

    if (!response.ok) {
        throw new Error('Failed to fetch user profile')
    }

    const profileData: UserProfile = await response.json()
    return profileData
}

export async function updateUserProfile(profile: UpdateProfileRequest) {
    const token = localStorage.getItem('token')
    const userId = localStorage.getItem('userId')

    if (!token || !userId) {
        throw new Error('User not authenticated')
    }

    const response = await fetch(`${apiUrl}/me/${userId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(profile),
    })

    if (!response.ok) {
        throw new Error('Failed to update user profile')
    }

    const updatedProfile: UserProfile = await response.json()
    return updatedProfile
}

export interface UserProfile {
    id: number
    first_name: string
    last_name: string
    email: string
    school: string
}

export interface UpdateProfileRequest {
    first_name: string
    last_name: string
    school: string
}
